import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useExpireSoa = (isLoading, onYesCallBack, onNoCallback = () => {}) => {
  const showComponent = true;

  const onHandleClick = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to expire all pending OVR SOA?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const component = showComponent ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-danger btn-round font-weight-bold"
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Expire SOA
      </button>
    </div>
  ) : null;

  return {
    onHandleClick,
    component,
  };
};

export default useExpireSoa;
